import { render, staticRenderFns } from "./DmpLogo.vue?vue&type=template&id=27411c3d&scoped=true&"
import script from "./DmpLogo.vue?vue&type=script&lang=js&"
export * from "./DmpLogo.vue?vue&type=script&lang=js&"
import style0 from "./DmpLogo.vue?vue&type=style&index=0&id=27411c3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27411c3d",
  null
  
)

export default component.exports